module.exports = __webpack_public_path__ + "static/banner-9-online-program-e6ce4fa0c9ec8b48af44b2133408448e.jpg";